import { render, staticRenderFns } from "./SAdminFAQUserList.vue?vue&type=template&id=d3fe1ec2&lang=pug"
import script from "./SAdminFAQUserList.vue?vue&type=script&lang=js"
export * from "./SAdminFAQUserList.vue?vue&type=script&lang=js"
import style0 from "./SAdminFAQUserList.vue?vue&type=style&index=0&id=d3fe1ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports